@use "styles/abstracts/build-variables" as bv;
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;
@use "styles/abstracts/mixins/typography" as t;

$event-color-white: v.$palette-pure-white;
$event-color: v.$palette-gray-900;
$event-accent-color: v.$palette-red;
$event-gray-light-color: v.$palette-gray-200;
$event-gray-dark-color: v.$palette-gray-300;

$subevent-info-margin-top: 12px;
$event-entry-margin-top: 24px;

$line-background-image: "#{bv.$svg-path}/vertical-dotted-line.svg";

$js-defined-subevent-info--height: 14px;

// Available classes for styling depend on logic:
// ".is-present-event", ".is-present-subevent", ".is-future-event", ".is-future-subevent"

%common-line-styles {
  content: '';
  display: block;
  position: absolute;
  left: -16px;
  width: 2px;
  background-color: transparent;
  z-index: -1;
}

.event-entry {
  font-style: normal;
  display: grid;
  grid-template-columns: minmax(35%, 65%) 1fr;
  grid-gap: 0 20px;

  @include c.containerMedia(800) {
    grid-template-columns: minmax(35%, 52%) 1fr;
  }
}

.event-entry + .event-entry {
  margin-top: $event-entry-margin-top;
}

.name {
  color: $event-accent-color;
  @include t.text(14px, 16px, 600);
  grid-column: 1/-1;
  position: relative;

  &:after, &:before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
    z-index: 1;
  }

  &:after {
    left: -17px;
    width: 4px;
    height: 4px;
    background-color: $event-color-white;
  }

  &:before {
    left: -21px;
    width: 12px;
    height: 12px;
    background-color: $event-accent-color;
  }
}

.description {
  position: relative;
  word-wrap: break-word;

  .subevent-arrow {
    position: absolute;
    display: block;
    top: 50%;
    left: -23px;
    transform: translateY(-50%);
  }

  &:before {
    @extend %common-line-styles;
  }

  &.is-present-subevent {
    &:before {
      top: -$subevent-info-margin-top - 2px; // aligning to circle
      height: calc(100% + #{$subevent-info-margin-top + 2px} /* compensation top position */);
      background-color: $event-accent-color;
    }
  }

  &.is-future-subevent {
    &:before {
      top: -$subevent-info-margin-top; // aligning to circle
      height: calc(100% + #{$subevent-info-margin-top} /* compensation top position */);
      background-image: url($line-background-image);
      background-repeat: repeat-y;
    }
  }

  &.is-last-subevent-within-entry {
    &:before {
      height: calc(100%
        + #{$subevent-info-margin-top} /* compensation top position */
        + #{$event-entry-margin-top} + 4px /* plus distance between event entries */
      );
    }
  }

  &.is-total-last-present-subevent {
    &:before {
      height: calc(100%);
      background-color: $event-accent-color;
    }
    &:after {
      @extend %common-line-styles;
      height: calc(100%
        + #{$subevent-info-margin-top} /* compensation top position */
      );
      background-image: url($line-background-image);
      background-repeat: repeat-y;
    }
  }

  &.is-last-event.is-last-subevent-within-entry {
    &:before {
      height: calc(100% + #{$subevent-info-margin-top});
    }
    &:after {
      display: none;
    }
  }
}

.subevent-info {
  margin-top: $subevent-info-margin-top;

  svg {
    circle {
      fill: $event-accent-color;
    }
  }
}

.subevent-info, .description {
  @include t.text(12px, 14px, 500);
  color: $event-color;
  min-height: $js-defined-subevent-info--height;
}

.is-future-event {
  .name {
    &:after {
      background-color: $event-gray-dark-color;
    }
    &:before {
      background-color: $event-gray-light-color;
    }
  }
}

.events-box {
  display: flex;
  flex-direction: column;
}
